import GridWrapper from "@components/elements/GridWrapper";
import BasicHeader from "@components/layouts/basic/headers";
import MainFooter from "@components/layouts/main/footers";
import { Box, makeStyles } from "@material-ui/core";
import Head from "next/head";
import React from "react";

const useStyles = makeStyles((theme) => ({
  root: {
    overflow: "hidden",
    // backgroundColor: theme.palette.primary.dark,
    // color: theme.palette.getContrastText(theme.palette.primary.dark),
  },
}));

interface Props {
  title: string;
  isAuth?: boolean;
  children?: React.ReactNode;
}

export default function BasicLayout(props: Props): JSX.Element {
  const { children, title, isAuth = false } = props;

  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <Head>
        <title>Best Golf Fitness</title>
      </Head>
      <BasicHeader></BasicHeader>

      <Box minHeight="80vh">
        <GridWrapper>{children}</GridWrapper>
      </Box>
      <MainFooter />
    </Box>
  );
}
